/** @module csi/action/_ImageBrowseMixin */
define([
	"dojo/_base/declare",
	"dojo/_base/lang",
	"csi/_base/underscore",
	"csi/comm",
	"csi/image/_base",
	"csi/image/Browser",
	"csi/reflection",
	"csi/comm/PostRequest",
	"csi/xml",
	"./_ImageSaveMixin"
], function(declare, lang, _, comm, imageBase, Browser, reflection, PostRequest, xml, _ImageSaveMixin) {

	// Classes that support Scene7 images
	var SCENE7_IMAGE_SUPPORT = {
		Colorway: 1,
		Style: 1
	};

	return declare(_ImageSaveMixin, {
		/** @property {boolean} bOneImage - indicate if constrained to selecting one image */
		bOneImage: false,

		/** @property {boolean} bShow3D - shows the 3D image selection on left grid */
		bShow3D: false,

		/** @property {string} browserFilter - default browser filter if any */
		browserFilter: null,

		/** @property {boolean} _bRefreshScene - true if browsing for images on node that supports Scene7 images */
		_bRefreshScene7: false,

		/**
		 * Extension point called when no images are selected in browser
		 */
		onBrowserCancel: function() { },

		/**
		 * Extension point called when images selected in browser
		 * @param {Node[]} nodes
		 */
		onBrowserSave: function(nodes) { },

		_preActionRequests: function(requests) {
			var node = this._getImageContext();

			if (node && SCENE7_IMAGE_SUPPORT[node.$Type]) {
				requests.push(new PostRequest("Apparel", "RefreshScene7Image").addParameter("ParentURL", node.$URL));
				this._bRefreshScene7 = true;
			}

			this.inherited(arguments);
		},

		/**
		 * Popup image browser
		 */
		preProcess: function() {
			var b = this._popupDialog = Browser.dialog();
			b.view.bShow3D = this.bShow3D;
			b.view.browserFilter = this.browserFilter;
			b.set("nodeContext", this._getImageContext());
			b.set("selectionMode", this.bOneImage ? "single" : "extended");
			b.set("title", this.getTitle());
			b.set("bAllowSelection", this.bAllowSelection);
			b.onSave = lang.hitch(this, this._onSave);
			b.onCancel = lang.hitch(this, this._onCancel);
			b.show();
			this.suspendProcess();
		},

		/**
		 * return item context for browsing image - usually it is the node being acted upon, but in some cases could be parent or other ancestor
		 * @return {Node}
		 */
		_getImageContext: function() {
			return this.getNode();
		},

		/**
		 * Finish action
		 */
		_onCancel: function() {
			this._popupDialog.hide();
			this.inherited(arguments);
			this.onBrowserCancel();
		},

		/**
		 * Hide browser and call onBrowserSave callback
		 * @param {Node[]} nodes
		 */
		onSave: function(nodes) {
			this._popupDialog.hide();
			this.onBrowserSave(nodes);
		}
	});
});